import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

/**
 * "MINHAS LISTAS ───" / "SEU PAINEL ───" — eyebrow with an inline rule, no title below it.
 *
 * Two sizes because the two screens using the pattern were drawn that way: `subtle` for the
 * dashboard and the creation wizard, `brand` for the Host Panel, which opens each section
 * with the brand eyebrow (`eyebrow--brand` in the prototype).
 */

type SectionLabelTone = "subtle" | "brand";

const TONE: Record<SectionLabelTone, { wrapper: string; label: string }> = {
  subtle: {
    wrapper: "mb-[22px] gap-[14px]",
    label: "text-[11px] text-fg-subtle",
  },
  brand: {
    wrapper: "mb-2 gap-3",
    label: "text-[15px] text-tb-green",
  },
};

export function SectionLabel({
  children,
  tone = "subtle",
  rule = true,
  className,
}: {
  children: React.ReactNode;
  tone?: SectionLabelTone;
  /**
   * The inline rule after the label. The host panel's prototype draws it on the panel's section
   * openers and **not** on the catalog's two eyebrows (the hero's and the grid's), which stand
   * alone above their titles.
   */
  rule?: boolean;
  className?: string;
}) {
  return (
    <div className={cn("flex items-baseline", TONE[tone].wrapper, className)}>
      <span
        className={cn(
          "whitespace-nowrap font-medium uppercase tracking-[0.16em]",
          TONE[tone].label,
        )}
      >
        {children}
      </span>
      {rule ? <Separator className="flex-1" /> : null}
    </div>
  );
}
